import { render } from "./ActivityDetailsReport.vue?vue&type=template&id=b9b0d77c&scoped=true"
import script from "./ActivityDetailsReport.vue?vue&type=script&lang=js"
export * from "./ActivityDetailsReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=b9b0d77c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b0d77c"]])

export default __exports__